module.exports = __webpack_public_path__ + "img/graduation-cap.a3179f4a.svg";